const keyFor = (databaseId: string) => `bdb-bulk-verification-run:${databaseId}`;

/** The database's last Bulk Verification Run, so its summary survives a reload. */
export const storedBulkVerificationRunId = (
  databaseId: string,
): string | null => {
  try {
    return window.localStorage.getItem(keyFor(databaseId));
  } catch {
    return null;
  }
};

export const rememberBulkVerificationRun = (
  databaseId: string,
  runId: string,
): void => {
  try {
    window.localStorage.setItem(keyFor(databaseId), runId);
  } catch {
    // Storage blocked: the summary just won't survive a reload.
  }
};

export const forgetBulkVerificationRun = (databaseId: string): void => {
  try {
    window.localStorage.removeItem(keyFor(databaseId));
  } catch {
    // Storage blocked: nothing was stored.
  }
};
